/** How a customer reaches EmitIQ - **read from the deployment's settings, never typed here.**
 *
 * KD's rule of 2026-11-01: nothing environment- or customer-specific is hardcoded; each such value
 * has one configurable home. This address was a constant in this file (set 2026-10-23, with an
 * argument that "a build variable would be a second place the address could be wrong"). That
 * argument is why it is not a build variable now either: it is `Settings.support_email` on the
 * server (`EMITIQ_SUPPORT_EMAIL`, set from `var.support_email` in `infra/platform/api.tf`) and the
 * SPA reads it from `GET /api/v1/config`. One home, and a change is a configuration change, not a
 * redeploy of the bundle.
 *
 * **`null` means no support address has been decided**, and the Contact tab says exactly that. It
 * is also what this returns while the read is in flight or if it failed: a made-up address is the
 * thing this product refuses to print - mail sent to a mailbox nobody reads is worse than being
 * told there is none. It should be a role address on the company's own domain (ADR-0055), not a
 * person's, and the group must exist before it is set: nothing here can check that.
 *
 * **Support cases are not in this product.** P-08 (2026-10-18) moved them to a separate internal
 * admin application, which needs its own ADR before anything of it is built, because it is the one
 * surface that sees across tenants (ADR-0041). So this is a *contact*, not a queue: no ticket
 * number, no response time and no status page are implied, and the tab says so.
 */

import { useConfig } from "../api/config";

export function useSupportEmail(): string | null {
  return useConfig().data?.support_email ?? null;
}
